const c = {
  name: "BallBeach",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M40,20c0-5.4-2.1-10.3-5.6-13.9c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1-0.1-0.1-0.1-0.2-0.2C30.3,2.2,25.4,0,20,0
			C9,0,0,9,0,20s9,20,20,20C31,40,40,31,40,20z M20,2c2.2,0,4.3,0.4,6.3,1.1c-1,0-2,0.2-3,0.4c-4.2,0.9-8.6,3.5-12.5,7.3
			C7,14.6,4.5,19.1,3.5,23.3c-0.2,1-0.4,2-0.4,3C2.4,24.3,2,22.2,2,20C2,10.1,10.1,2,20,2z M20,38c-2.2,0-4.3-0.4-6.3-1.1
			c1,0,2-0.2,3-0.4c4.2-0.9,8.6-3.5,12.5-7.3c3.8-3.8,6.3-8.3,7.3-12.5c0.2-1,0.4-2,0.4-3c0.7,1.9,1.1,4.1,1.1,6.3
			C38,29.9,29.9,38,20,38z M34.5,10.2c0.6,1.7,0.6,3.8,0.1,6.1c-0.8,3.8-3.1,7.9-6.7,11.5c-3.6,3.6-7.7,5.9-11.5,6.7
			C14,35,11.9,35,10.2,34.5c1-0.3,2.1-0.9,3.3-1.6c3.2-1.8,7-4.9,10.7-8.6c3.8-3.8,6.8-7.6,8.6-10.7C33.6,12.3,34.1,11.2,34.5,10.2z
			 M32.8,7.3c0.1,0.1,0.2,0.5,0,1.5c-0.2,1-0.8,2.2-1.6,3.7c-1.7,3-4.6,6.7-8.3,10.3c-3.7,3.7-7.4,6.6-10.3,8.3
			C11,32,9.7,32.6,8.8,32.8c-1,0.2-1.4,0.1-1.5-0.1l0,0c-0.1-0.1-0.3-0.5-0.1-1.5c0.2-1,0.8-2.2,1.6-3.7c1.7-3,4.6-6.7,8.3-10.3
			c3.7-3.7,7.4-6.6,10.3-8.3C29,8,30.3,7.4,31.2,7.2C32.2,7,32.6,7.1,32.8,7.3C32.7,7.3,32.7,7.3,32.8,7.3z M5.5,29.8
			C5,28.1,5,26,5.5,23.7c0.8-3.8,3.1-7.9,6.7-11.5c3.6-3.6,7.7-5.9,11.5-6.7C26,5,28.1,5,29.8,5.5c-1,0.3-2.1,0.9-3.3,1.6
			c-3.2,1.8-7,4.9-10.7,8.6S9,23.3,7.1,26.5C6.4,27.7,5.9,28.8,5.5,29.8z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as BallBeach
};
